import { PermissionsEnum } from "@/auth/interfaces";
import {
  a11yProps,
  EstadoPreventaEnum,
  hasPermission,
  ROUTER_PATHS,
  sizeTab,
  texto,
  useCheckPermissions,
} from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import TablePreventaCorporativo from "../../shared/table_preventa_corporativo/TablePreventaCorporativo";


export default function PreventaCorporativoPage() {
  useCheckPermissions(PermissionsEnum.api_view_preventacoorporativa);
  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title={"Oportunidad Comercial"}
      visibleReport={true}
      textRedirect="Oportunidad con Proyecto Previo"
      enableRedirect={hasPermission(
        PermissionsEnum.api_add_preventacoorporativa
      )}
      urlRedirect={ROUTER_PATHS.ventasCorporativas.nPreventaCorporativoCrearNav}
    >
      <Box
        sx={{
          bgcolor: "background.paper",
          maxWidth: sizeTab,
          paddingBottom: 2,
        }}
      >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={"Oportunidades Comerciales"} {...a11yProps(0)} />
          {/* <Tab label={'Preventas Aprobadas'} {...a11yProps(1)} /> */}
          <Tab label={"En Proceso"} {...a11yProps(1)} />
          <Tab label={texto.realizadas} {...a11yProps(2)} />
          <Tab label={texto.cancelado} {...a11yProps(3)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TablePreventaCorporativo
          enableEditing={true}
          showCustomActionBtnSpace={true}
          estado_preventa={`${EstadoPreventaEnum.EN_ESPERA},${EstadoPreventaEnum.PREAPROBADA}`} 
          // aprueba_plan_personalizado={false}
        />
      </CustomTabPanel>
      {/* <CustomTabPanel value={valueTab} index={1}>
        <TablePreventaCorporativo 
          enableEditing={true}
          showCustomActionBtnSpace={true}
          estado_preventa={EstadoPreventaEnum.PREAPROBADA}
        />
      </CustomTabPanel> */}
      <CustomTabPanel value={valueTab} index={1}>
        <TablePreventaCorporativo
          enableEditing={true}
          showCustomActionBtnSpace={true}
          estado_preventa={EstadoPreventaEnum.EN_PROCESO}
          // aprueba_plan_personalizado={true}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <TablePreventaCorporativo
          enableEditing={false}
          showCustomActionBtnSpace={true}
          estado_preventa={EstadoPreventaEnum.FINALIZADO}
          viewOnlyMode={true}
          // aprueba_plan_personalizado={true}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={3}>
        <TablePreventaCorporativo
          enableEditing={false}
          showCustomActionBtnSpace={true}
          estado_preventa={EstadoPreventaEnum.CANCELADO}
          viewOnlyMode={true}
          // aprueba_plan_personalizado={undefined}
        />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
}
